import { createAction, props } from '@ngrx/store';
import {
  CmsDynamicFeatureCopy,
  CmsDynamicFlows,
  CmsDynamicKeys,
  CmsDynamicSubFlows,
  CmsFeatureCopy,
  CmsKeys,
  ContentPageKeys, DynamicPageResponse,
  FeaturePageKeys,
} from '@constants/cms.constants';
import { CultureKeyType, FlowBaseUrlEnum } from '@constants/app.constants';
import { DisruptionBanner } from '@models/cms/disruption-banner.model';

export const enum CmsActionTypes {
  loadCopy = '[CMS] LOAD_COPY',
  copyLoaded = '[CMS] COPY_LOADED',
  copyLoadFailed = '[CMS] COPY_LOAD_FAILED',

  loadFlowCopy = '[CMS] LOAD_FLOW_COPY',
  copyLoadFlowFailed = '[CMS] COPY_LOAD_FLOW_FAILED',

  loadDynamicCopy = '[CMS] LOAD_DYNAMIC',
  dynamicCopyLoaded = '[CMS] DYNAMIC_COPY_LOADED',
  dynamicCopyLoadFailed = '[CMS] DYNAMIC_COPY_LOAD_FAILED',

  resetCms = '[CMS] RESET_CMS',
  disruptionBannersLoad = '[CMS] DISRUPTION_BANNERS_LOAD',
  disruptionBannersSuccess = '[CMS] DISRUPTION_BANNERS_SUCCESS',
  disruptionBannersClear = '[CMS] DISRUPTION_BANNERS_CLEAR',
  disruptionBannersRemove = '[CMS] DISRUPTION_BANNERS_REMOVE',

  updateActiveDynamicPage = '[CMS] UPDATE_ACTIVE_DYNAMIC_PAGE',
}

export const resetCms = createAction(
  CmsActionTypes.resetCms,
  props<{
    culture: CultureKeyType;
  }>(),
);

export const cmsLoadCopy = createAction(
  CmsActionTypes.loadCopy,
  props<{
    key: CmsKeys;
  }>(),
);

export const cmsLoadDynamicCopy = createAction(
  CmsActionTypes.loadDynamicCopy,
  props<{
    flowKey: CmsDynamicFlows;
    subFlowKey?: CmsDynamicSubFlows;
    cmsKey?: CmsDynamicKeys;
  }>(),
);

export const cmsLoadFlowCopy = createAction(
  CmsActionTypes.loadFlowCopy,
  props<{
    key?: CmsKeys;
    contentPageKey?: ContentPageKeys;
    dynamicPageKey?: string;
    featurePageKey?: FeaturePageKeys;
  }>(),
);

export const cmsCopyLoaded = createAction(
  CmsActionTypes.copyLoaded,
  props<{
    data: CmsFeatureCopy | DynamicPageResponse;
    flow?: FlowBaseUrlEnum;
    key?: CmsKeys | ContentPageKeys | FeaturePageKeys | string;
  }>(),
);

export const cmsDynamicCopyLoaded = createAction(
  CmsActionTypes.dynamicCopyLoaded,
  props<{
    data: CmsDynamicFeatureCopy;
    flow: CmsDynamicFlows;
    subFlow?: CmsDynamicSubFlows;
    key?: CmsDynamicKeys;
  }>(),
);

export const cmsCopyLoadFlowFailed = createAction(
  CmsActionTypes.copyLoadFlowFailed,
  props<{
    key?: CmsKeys | ContentPageKeys | FeaturePageKeys | string;
  }>(),
);

export const cmsCopyLoadFailed = createAction(
  CmsActionTypes.copyLoadFailed,
  props<{
    key: CmsKeys;
  }>(),
);

export const cmsDynamicCopyLoadFailed = createAction(
  CmsActionTypes.dynamicCopyLoadFailed,
  props<{
    flow: CmsDynamicFlows;
    subFlow?: CmsDynamicSubFlows;
    key?: CmsDynamicKeys;
  }>(),
);

//DISRUPTION BANNERS
export const cmsDisruptionBannersLoad = createAction(
  CmsActionTypes.disruptionBannersLoad,
  props<{ cultureCode: string }>()
);

export const cmsDisruptionBannersSuccess = createAction(
  CmsActionTypes.disruptionBannersSuccess,
  props<{ banners: DisruptionBanner[] }>()
);

export const cmsDisruptionBannersClear = createAction(
  CmsActionTypes.disruptionBannersClear
);

export const cmsDisruptionBannerRemove = createAction(
  CmsActionTypes.disruptionBannersRemove,
  props<{ id: string }>()
);

export const updateActiveDynamicPage = createAction(
  CmsActionTypes.updateActiveDynamicPage,
  props<{ name: string }>()
);
